import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Map } from "immutable";
import { FormSection } from "redux-form";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import ShippingFields from "MODULES/Orders/shared/ShippingFields";
import * as actions from "MODULES/inventories/actions";
import { COMPANY } from "MODULES/companies/constants";
import { DROPSHIP } from "MODULES/PurchaseOrders/constants";
import {
  ACCOUNT_NUMBER,
  CARRIER,
  SHIP_TO_COMPANY_ADDRESS_ID,
  SHIP_TO_COMPANY_ID,
  SHIP_TO_FOB,
  SHIP_TO_SHIPPING_ADDRESS,
  SHIP_TO_SHIPPING_METHOD,
  SHIP_TO_TYPE,
  SHIPPING_METHOD
} from "APP_ROOT/constants";
import { fobFormat } from "LIB/formatters/address";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import validate from "./validate";

const FORM_NAME = "return-to-customer-record-form";

export function Form(props) {
  const { inventory, setFieldValue } = props;

  const rma = inventory.most_recent_customer_rma;

  const onChangeShippingPreference = shippingMethod => {
    [CARRIER, SHIPPING_METHOD, ACCOUNT_NUMBER].forEach(f => {
      setFieldValue(`${SHIP_TO_SHIPPING_METHOD}.${f}`)(shippingMethod[f]);
    });
  };

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormSection name="">
          <h4>Ship To</h4>
          <ShippingFields
            shipToCompany={rma.company}
            formName={FORM_NAME}
            hasLocations={false}
            onChangeShippingPreference={onChangeShippingPreference}
            shippingFields={[
              SHIP_TO_TYPE,
              SHIP_TO_COMPANY_ID,
              SHIP_TO_COMPANY_ADDRESS_ID
            ]}
            shippingTypes={[COMPANY, DROPSHIP]}
            shippingMethod={SHIP_TO_SHIPPING_METHOD}
            shippingAddressField={SHIP_TO_SHIPPING_ADDRESS}
            required={false}
          />
        </FormSection>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  rma: T.instanceOf(Map)
};

export default connect(
  (state, ownProps) => ({
    initialValues: {
      [SHIP_TO_FOB]: fobFormat(ownProps.inventory.store_location),
      [SHIP_TO_TYPE]: COMPANY
    }
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(actions.returnToCustomerV2(ownProps.inventory.id, data))
  })
)(
  form({
    form: FORM_NAME,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/inventories/components/Detail/Header/DropdownActions/ReturnToCustomer/Form.jsx